/*eslint-disable */
export default class GeolocationService {
  /**
   * A promise based wrapper for geolocation web API.
   * @param options navigator.geolocation.getCurrentPosition options object to be injected.
   */
    // eslint-disable-next-line arrow-body-style
  static getCurrentPosition = (options: object = {}): Promise<any> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
  }
}
